import { Network } from "./types";

// Chain identity only — no token addresses. Those are a property of the payments contract's
// registry, not of the chain, and there is more than one of them; see ./tokens.ts.
// The RPC endpoint is not here either: it is injected at boot from the backend's /appConfig
// (./config.ts).
export const CHAINS: Record<Network, { chainId: bigint }> = {
  mainnet: { chainId: BigInt(137) },
  testnet: { chainId: BigInt(80002) },
};

export function chainIdFor(network: Network): bigint {
  return CHAINS[network].chainId;
}
